import { graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';

import { IContentfulImage } from '../../../interfaces/contentful-image.interface';

export interface FullWidthImageMosaicProps {
  largeImage: IContentfulImage;
  firstSmallImage: IContentfulImage;
  secondSmallImage: IContentfulImage;
  topBlock?: boolean;
}

const EditorialFullWidthImageMosaicBlock = ({
  largeImage,
  firstSmallImage,
  secondSmallImage,
  topBlock,
}: FullWidthImageMosaicProps) => {
  const imageCss =
    'rounded-card-mobile mx-auto transform-gpu ' +
    (largeImage
      ? 'aspect-1/0.75 lg:max-h-none max-h-[860px] w-full lg:max-w-none max-w-[645px] '
      : 'aspect-1.5/1 max-h-[430px] max-w-[645px] ');

  const largeImageData: any = largeImage?.gatsbyImageData
    ? largeImage?.gatsbyImageData
    : null;
  const firstSmallImageData: any = firstSmallImage?.gatsbyImageData
    ? firstSmallImage?.gatsbyImageData
    : null;
  const secondSmallImageData: any = secondSmallImage?.gatsbyImageData
    ? secondSmallImage?.gatsbyImageData
    : null;

  return (
    <div
      className={
        'flex flex-col items-center gap-5 px-5 sm:flex-row sm:items-start sm:gap-4 sm:px-0 ' +
        (topBlock ? 'pt-5 lg:pt-0 ' : 'lg:my-5 ')
      }
    >
      <GatsbyImage
        image={largeImageData}
        alt={largeImage?.description ? largeImage?.description : ''}
        className={imageCss}
      />
      <div className="flex w-full flex-col gap-5 sm:gap-4">
        <GatsbyImage
          image={firstSmallImageData}
          alt={firstSmallImage?.description ? firstSmallImage?.description : ''}
          className={imageCss}
        />
        <GatsbyImage
          image={secondSmallImageData}
          alt={
            secondSmallImage?.description ? secondSmallImage?.description : ''
          }
          className={imageCss}
        />
      </div>
    </div>
  );
};

export default EditorialFullWidthImageMosaicBlock;

export const query = graphql`
  fragment BlockEditorialFullWidthImageMosaic on ContentfulBlockEditorialFullWidthImageMosaic {
    blocktype: __typename
    largeImage {
      description
      gatsbyImageData(width: 1200, height: 1600, formats: AVIF)
    }
    firstSmallImage {
      description
      gatsbyImageData(width: 1500, height: 1000, formats: AVIF)
    }
    secondSmallImage {
      description
      gatsbyImageData(width: 1500, height: 1000, formats: AVIF)
    }
  }
`;
